import { render } from "./LoginFooter.vue?vue&type=template&id=e30eab94&scoped=true"
import script from "./LoginFooter.vue?vue&type=script&lang=js"
export * from "./LoginFooter.vue?vue&type=script&lang=js"

import "./LoginFooter.vue?vue&type=style&index=0&id=e30eab94&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e30eab94"]])

export default __exports__